// api.js — the one place the site's API lives. REACT_APP_API_URL overrides
// the production endpoint (e.g. for a local or staging API).

export const API_URL =
  process.env.REACT_APP_API_URL ||
  "https://hyrqv0ey6a.execute-api.us-east-2.amazonaws.com/scores";

const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

// GET /scores?<query> as JSON; throws on a non-2xx response. Throttling (503
// or 429, e.g. when the account's Lambda concurrency is exhausted) is retried
// twice with a short backoff.
export async function fetchScores(query) {
  for (let attempt = 0; ; attempt++) {
    const r = await fetch(`${API_URL}?${query}`);
    if (r.ok) return r.json();
    if (attempt < 2 && (r.status === 503 || r.status === 429)) {
      await sleep(400 * (attempt + 1) + Math.random() * 200);
      continue;
    }
    throw new Error(`HTTP ${r.status}`);
  }
}

// Map `fn` over `items` with at most `limit` requests in flight, so a page
// never bursts past the API's concurrency.
export async function mapLimit(items, limit, fn) {
  const out = new Array(items.length);
  let next = 0;
  const worker = async () => {
    while (next < items.length) {
      const i = next++;
      out[i] = await fn(items[i]);
    }
  };
  await Promise.all(Array.from({ length: Math.min(limit, items.length) }, worker));
  return out;
}

// Responses a pre-rendered page was built with (scripts/prerender.js embeds
// them as window.__PL_API_CACHE__). Pages use these for their first render so
// it matches the saved HTML, then refresh from the API.
export const cachedScores = (query) =>
  typeof window !== "undefined" && window.__PL_API_CACHE__ ? window.__PL_API_CACHE__[query] : undefined;
